var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertWeather01 = function SvgAlertWeather01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert_weather-01_svg2__a",
    x1: 37.14,
    x2: 186.65,
    y1: 211.17,
    y2: 65.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_weather-01_svg2__a",
    id: "alert_weather-01_svg2__b",
    x1: 29.02,
    x2: 178.52,
    y1: 202.85,
    y2: 56.73
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_weather-01_svg2__a",
    id: "alert_weather-01_svg2__c",
    x1: 24.55,
    x2: 174.06,
    y1: 198.28,
    y2: 52.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_weather-01_svg2__a",
    id: "alert_weather-01_svg2__d",
    x1: 16.42,
    x2: 165.93,
    y1: 189.97,
    y2: 43.85
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_weather-01_svg2__a",
    id: "alert_weather-01_svg2__e",
    x1: 11.96,
    x2: 161.47,
    y1: 185.4,
    y2: 39.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_weather-01_svg2__a",
    id: "alert_weather-01_svg2__f",
    x1: 3.83,
    x2: 153.34,
    y1: 177.08,
    y2: 30.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_weather-01_svg2__a",
    id: "alert_weather-01_svg2__g",
    x1: 23.08,
    x2: 172.59,
    y1: 196.78,
    y2: 50.66
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_weather-01_svg2__a",
    id: "alert_weather-01_svg2__h",
    x1: 52.92,
    x2: 202.42,
    y1: 227.31,
    y2: 81.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_weather-01_svg2__a",
    id: "alert_weather-01_svg2__i",
    x1: 70.7,
    x2: 220.2,
    y1: 245.5,
    y2: 99.38
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M62.56 182.29a2.92 2.92 0 0 0-3.95 1.15l-6.7 12.24a2.904 2.904 0 0 0 1.16 3.95 2.92 2.92 0 0 0 3.96-1.15l6.7-12.24c.77-1.41.26-3.18-1.16-3.95Z",
    style: {
      fill: "url(#alert_weather-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.95 147.09a2.91 2.91 0 0 0-3.95 1.15l-6.7 12.24a2.904 2.904 0 0 0 1.16 3.95 2.92 2.92 0 0 0 3.96-1.15l6.7-12.24c.77-1.41.26-3.18-1.16-3.95Z",
    style: {
      fill: "url(#alert_weather-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.79 182.29a2.92 2.92 0 0 0-3.95 1.15l-6.7 12.24a2.904 2.904 0 0 0 1.16 3.95 2.92 2.92 0 0 0 3.96-1.15l6.7-12.24c.77-1.41.26-3.18-1.16-3.95Z",
    style: {
      fill: "url(#alert_weather-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.17 147.09a2.91 2.91 0 0 0-3.95 1.15l-6.7 12.24a2.904 2.904 0 0 0 1.16 3.95 2.92 2.92 0 0 0 3.96-1.15l6.7-12.24c.77-1.41.26-3.18-1.16-3.95Z",
    style: {
      fill: "url(#alert_weather-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.01 182.29a2.91 2.91 0 0 0-3.95 1.15l-6.7 12.24a2.904 2.904 0 0 0 1.16 3.95 2.92 2.92 0 0 0 3.96-1.15l6.7-12.24c.77-1.41.26-3.18-1.16-3.95Z",
    style: {
      fill: "url(#alert_weather-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 147.09a2.92 2.92 0 0 0-3.95 1.15l-6.7 12.24a2.904 2.904 0 0 0 1.16 3.95 2.92 2.92 0 0 0 3.96-1.15l6.7-12.24c.77-1.41.26-3.18-1.16-3.95Z",
    style: {
      fill: "url(#alert_weather-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.05 117.35c17.62-.04 31.95-14.39 31.95-32.02 0-16.47-12.68-30.21-28.79-31.85-1.4-17.21-15.85-30.78-33.41-30.78-7.56 0-14.71 2.47-20.56 7.04C110.38 12.03 93.13 0 73.82 0 48.15 0 27.27 20.88 27.27 46.55c0 2.36.18 4.72.53 7.05C11.99 55.66.05 69 .05 85.33c0 17.66 14.36 32.02 32.02 32.02h11.4l-4.34 7.92a2.904 2.904 0 0 0 1.16 3.95 2.92 2.92 0 0 0 3.96-1.15l5.87-10.72h19.13l-4.34 7.92a2.904 2.904 0 0 0 1.16 3.95 2.92 2.92 0 0 0 3.96-1.15l5.87-10.72h19.13l-4.34 7.92a2.904 2.904 0 0 0 1.16 3.95 2.92 2.92 0 0 0 3.96-1.15l5.87-10.72h19.96l-29.51 57.9c-2.71 5.31-2.46 11.52.65 16.61s8.54 8.12 14.5 8.12h75.14c5.96 0 11.38-3.04 14.5-8.12s3.36-11.29.65-16.61l-29.51-57.91Zm-135.98-5.82c-14.44 0-26.19-11.75-26.19-26.2s11.19-25.79 25.47-26.18a2.904 2.904 0 0 0 2.76-3.55c-.67-2.95-1.01-6-1.01-9.05 0-22.45 18.27-40.72 40.72-40.72 18.24 0 34.38 12.26 39.25 29.82a2.9 2.9 0 0 0 2.08 2.04c1.01.26 2.08-.04 2.81-.79 5.26-5.4 12.31-8.38 19.84-8.38 15.25 0 27.67 12.39 27.7 27.64v.07a2.91 2.91 0 0 0 2.87 2.91c14.23.21 25.81 11.95 25.81 26.18s-11.75 26.2-26.19 26.2h-2.9l-5.1-10c-2.92-5.73-8.72-9.28-15.15-9.28s-12.23 3.56-15.15 9.28l-5.1 10H32.07Zm159.87 77.29c-2.05 3.34-5.61 5.34-9.53 5.34h-75.14c-3.92 0-7.49-2-9.53-5.34a11.1 11.1 0 0 1-.43-10.92l37.57-73.73c1.95-3.82 5.67-6.1 9.96-6.1s8.01 2.28 9.96 6.1l37.57 73.73c1.78 3.49 1.62 7.58-.43 10.92",
    style: {
      fill: "url(#alert_weather-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 152.19c1.61 0 2.91-1.3 2.91-2.91v-23.61c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v23.61c0 1.61 1.3 2.91 2.91 2.91",
    style: {
      fill: "url(#alert_weather-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.45 170.62a3.4 3.4 0 0 0-.49-.27c-.18-.07-.36-.13-.55-.16-.37-.08-.76-.08-1.14 0-.18.04-.37.1-.54.16-.18.08-.34.16-.51.27-.16.11-.31.23-.44.36-.54.54-.85 1.3-.85 2.06 0 .19.02.39.06.57a2.96 2.96 0 0 0 .42 1.04c.11.16.23.31.37.45.54.53 1.29.84 2.06.84s1.52-.31 2.06-.84c.14-.14.25-.29.36-.45.11-.15.19-.33.27-.5.07-.17.13-.36.16-.54.04-.18.06-.38.06-.57 0-.77-.31-1.51-.85-2.06-.14-.13-.28-.25-.45-.36",
    style: {
      fill: "url(#alert_weather-01_svg2__i)"
    }
  }));
};
export default SvgAlertWeather01;